import watchMenu from "./userMenu/userMenu";
export default function* rootSaga() {
  yield watchMenu();
}
